import Api, { Cloud } from '@silbo/core';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from '../../../../toast';

export const useLinkExternalUserMutation = () => {
  const { t } = useTranslation('bed-management');

  return useMutation({
    mutationFn: async ({ id, username, accessToken }: { id: string; username: string; accessToken: string }) => {
      // Sans installationId sur la session créée côté serveur, les push FCM ne résolvent pas l'appareil.
      const installationId = await Api._getInstallationId();
      const { sessionToken } = await Cloud.linkExternalUser({ id, username, accessToken, installationId });

      // Session is created server-side; we only adopt it here (avoids Parse.User.logInWith
      // hitting POST /users which is blocked by parse-server ≥ 9.6.0-alpha.41).
      return Api.User.become(sessionToken);
    },
    onError: () => {
      console.error('Failed to link external user');
      toast.error(t('auth.linkExternalUserError'));
    },
  });
};
